<template>
  <div>
    <section class="mail-tips">
      <span style="font-size: 14px; font-weight: bold">补全资料须知</span>
      <p style="font-size: 12px">
        请选择您所在的网点，填入您的主手机号（如有多个手机号，请选择绑定更多手机号）。
      </p>
    </section>
    <div class="weui-cells" style="margin-top: 0px">
      <a class="weui-cell weui-cell_access" href="javascript:;">
        <div class="weui-cell__bd">
          <p>头像</p>
        </div>
        <div class="weui-cell__hd" v-if="headimgBase64">
          <img
            :src="'data:image/png;base64,' + headimgBase64"
            alt=""
            style="margin-right: 5px; display: block"
          />
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        @click="chooseWorksite"
      >
        <div class="weui-cell__bd">
          <p>
            网点
            <font class="redTips">*</font>
          </p>
        </div>
        <div class="weui-cell__ft">{{ worksite.label }}</div>
      </a>
    </div>

    <div class="weui-cells__title" style="color: red">绑定主手机号（必须）</div>
    <div class="weui-cells weui-cells_form" style="margin-top: 10px">
      <div class="weui-cell weui-cell_vcode" v-if="userInfo.phoneMain">
        <div class="weui-cell__hd">
          已绑号码<font class="redTips" style="margin-left: 5px">*</font>
        </div>
        <div class="weui-cell__bd" style="text-align: right">
          {{ userInfo.phoneMain }}
        </div>
        <div class="weui-cell__ft" @click="change">
          <button class="weui-vcode-btn">
            {{ showPhoneMainInput ? "不换号" : "换号" }}
          </button>
        </div>
      </div>
      <div class="weui-cell weui-cell_vcode" v-if="showPhoneMainInput">
        <div class="weui-cell__hd">
          <label class="weui-label"
            >主手机号
            <font class="redTips">*</font>
          </label>
        </div>
        <div class="weui-cell__bd">
          <input
            class="weui-input"
            type="number"
            v-model="phoneMain"
            oninput="if(value.length>11)value=value.slice(0,11)"
            placeholder="请输入主手机号"
          />
        </div>
        <div class="weui-cell__ft" @click="getPhoneCaptchaMain">
          <button class="weui-vcode-btn">{{ getPhoneCaptchaMainLabel }}</button>
        </div>
      </div>
      <div class="weui-cell weui-cell_access" v-if="showPhoneMainInput">
        <div class="weui-cell__hd">
          <label class="weui-label">验证码</label>
        </div>
        <div class="weui-cell__bd">
          <input
            class="weui-input"
            type="number"
            v-model="phoneMainCaptcha"
            oninput="if(value.length>4)value=value.slice(0,4)"
            placeholder="主手机号验证码"
          />
        </div>
      </div>
      <div class="weui-cell weui-cell_switch">
        <label class="weui-cell__bd">绑定更多手机号</label>
        <div class="weui-cell__ft">
          <label for="switchCP" class="weui-switch-cp">
            <input
              id="switchCP"
              class="weui-switch-cp__input"
              type="checkbox"
              v-model="bindVicePhone"
            />
            <div class="weui-switch-cp__box"></div>
          </label>
        </div>
      </div>
      <div class="weui-cell weui-cell_vcode" v-if="bindVicePhone">
        <div class="weui-cell__hd">
          <label class="weui-label">副手机号</label>
        </div>
        <div class="weui-cell__bd">
          <input
            class="weui-input"
            type="number"
            v-model="phoneVice"
            oninput="if(value.length>11)value=value.slice(0,11)"
            placeholder="请输入副手机号"
          />
        </div>
        <div class="weui-cell__ft" @click="getPhoneCaptchaVice">
          <button class="weui-vcode-btn">{{ getPhoneCaptchaViceLabel }}</button>
        </div>
      </div>
      <div class="weui-cell weui-cell_access" v-if="bindVicePhone">
        <div class="weui-cell__hd">
          <label class="weui-label">验证码</label>
        </div>
        <div class="weui-cell__bd">
          <input
            class="weui-input"
            type="number"
            v-model="phoneViceCaptcha"
            oninput="if(value.length>4)value=value.slice(0,4)"
            placeholder="副手机号验证码"
          />
        </div>
      </div>
    </div>

    <div
      class="warehousing-footer-item sureinwarehousing"
      style="flex: 2"
      @click="addUserInfo"
    >
      <a href="javascript:;">提 交</a>
    </div>

    <div id="toast" v-if="needIdCard">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i
          class="weui-icon-waiting weui-icon_toast"
          style="font-size: 36px; margin-bottom: 10px"
        ></i>
        <p class="weui-toast__content">寄件须先实名</p>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      showPhoneMainInput: true,
      headimgBase64: "",
      lon: "0",
      lat: "0",
      worksite: {
        label: "请选择",
        value: -1,
      },
      userInfo: {},
      phoneMain: "",
      phoneMainCaptcha: "",
      bindVicePhone: false,
      phoneVice: "",
      phoneViceCaptcha: "",
      getPhoneCaptchaMainLabel: "获取验证码",
      getPhoneCaptchaViceLabel: "获取验证码",
      needIdCard: false,
      encodeToken: "",
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    let token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    let choosedWs = sessionStorage.getItem("choosedWs");
    if (choosedWs) {
      this.worksite = JSON.parse(choosedWs);
    }

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then((response) => {
        this.userInfo = response.data.data;
        console.log(this.userInfo);
        if (this.userInfo.phoneMain) {
          this.showPhoneMainInput = false;
        }
        that.headimgBase64 = response.data.data.headimgBase64;
      })
      .catch((error) => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    chooseWorksite() {
      let redirect = this.$route.params.redirect;
      this.$router.push({
        name: "WorksiteList",
        params: {
          token: this.encodeToken,
          from: "addUserInfo",
          redirect: redirect,
        },
      });
    },
    change() {
      this.showPhoneMainInput = !this.showPhoneMainInput;
    },
    getPhoneCaptchaMain() {
      if (this.getPhoneCaptchaMainLabel != "获取验证码") {
        return;
      } else {
        if (this.worksite.value == -1) {
          weui.alert("请选择您所在的网点");
          return;
        } else if (!this.phoneMain || this.phoneMain.length != 11) {
          weui.alert("请输入正确的主手机号码");
          return;
        } else {
          let that = this;
          axios
            .get("/api/user/phoneCaptcha/" + this.phoneMain)
            .then((res) => {
              if (res.data.success) {
                weui.toast("验证码已发送", 1500);
                let timeLong = 60;
                that.getPhoneCaptchaMainLabel = "还剩 " + timeLong + " s";
                let times = setInterval(function () {
                  timeLong--;
                  that.getPhoneCaptchaMainLabel = "还剩 " + timeLong + " s";
                  if (timeLong == 0) {
                    that.getPhoneCaptchaMainLabel = "获取验证码";
                    clearInterval(times);
                  }
                }, 1000);
              } else {
                weui.alert(res.data.message);
              }
            })
            .catch((err) => {
              weui.alert("获取验证码失败");
            });
        }
      }
    },
    getPhoneCaptchaVice() {
      if (this.getPhoneCaptchaViceLabel != "获取验证码") {
        return;
      } else {
        if (this.worksite.value == -1) {
          weui.alert("请选择您所在的网点");
          return;
        } else if (!this.phoneVice || this.phoneVice.length != 11) {
          weui.alert("请输入正确的副手机号码");
          return;
        } else {
          let that = this;
          axios
            .get("/api/user/phoneCaptcha/" + this.phoneVice)
            .then((res) => {
              if (res.data.success) {
                weui.toast("验证码已发送", 1500);
                let timeLong = 60;
                that.getPhoneCaptchaViceLabel = "还剩 " + timeLong + " s";
                let times = setInterval(function () {
                  timeLong--;
                  that.getPhoneCaptchaViceLabel = "还剩 " + timeLong + " s";
                  if (timeLong == 0) {
                    that.getPhoneCaptchaViceLabel = "获取验证码";
                    clearInterval(times);
                  }
                }, 1000);
              } else {
                weui.alert(res.data.message);
              }
            })
            .catch((err) => {
              weui.alert("获取验证码失败");
            });
        }
      }
    },
    addUserInfo() {
      if (this.worksite.value == -1) {
        weui.alert("请选择您所在的网点");
        return;
      } else if (
        this.showPhoneMainInput &&
        (!this.phoneMain || this.phoneMain.length != 11)
      ) {
        weui.alert("请填入正确的主手机号");
        return;
      } else if (
        this.showPhoneMainInput &&
        (!this.phoneMainCaptcha || this.phoneMainCaptcha.length != 4)
      ) {
        weui.alert("请输入正确的主号验证码");
        return;
      } else if (this.bindVicePhone && this.phoneVice.length != 11) {
        weui.alert("请输入正确的副手机号");
        return;
      } else if (this.bindVicePhone && this.phoneViceCaptcha.length != 4) {
        weui.alert("请输入正确的副号验证码");
        return;
      }

      let params = {
        worksite: this.worksite.value,
      };
      if (this.showPhoneMainInput) {
        params.phoneMain = this.phoneMain;
        params.phoneMainCaptcha = this.phoneMainCaptcha;
      }
      if (this.bindVicePhone) {
        params.phoneVice = this.phoneVice;
        params.phoneViceCaptcha = this.phoneViceCaptcha;
      }

      axios
        .put("/api/user/complete", params)
        .then((res) => {
          if (res.data.success) {
            weui.toast("提交成功", 1500);

            /**
             * 跳转到对应的请求地址
             * 跳转前先判断是否是跳转到寄件页面
             */
            let redirect = this.$route.params.redirect;
            if (
              redirect == "expressTotakein" &&
              !this.userInfo.idCardNo &&
              !this.userInfo.toAuthIdCardNo
            ) {
              // 还没上传身份证信息，跳转到身份证上传页面
              this.needIdCard = true;
              setTimeout(function () {
                this.needIdCard = false;
                this.$router.push(
                  "/authApply/0/expressTotakein/" + this.encodeToken
                );
              }, 1000);
            } else if (redirect.indexOf("wm-") >= 0) {
              // 外卖模块，需要跳转到外卖首页
              weui.loading("页面加载ing...", {
                className: "custom-classname",
              });
              let shareUserId = 0;
              if (localStorage.getItem("shareUserId")) {
                shareUserId = localStorage.getItem("shareUserId");
              }

              window.location.href =
                "http://live.aixyt.com/?/#/home/" +
                shareUserId +
                "/" +
                this.encodeToken;
            } else {
              this.$router.push("/home/" + this.encodeToken);
            }
          } else {
            weui.alert("验证码不正确或已失效");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.redTips {
  color: red;
  position: relative;
  top: 2px;
  vertical-align: middle;
  font-weight: bold;
}
.weui-cell__hd img {
  width: 50px;
  height: 50px;
  border-radius: 8px;
}
.weui-cell__bd input {
  text-align: right;
}
.weui-select {
  width: auto;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #feb70f;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
</style>






// WEBPACK FOOTER //
// src/components/AddUserInfo.vue